import  {createContext } from 'react';

 const CanvasContext = createContext(
    {
    }
  );
  
export default CanvasContext;